require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-wallpaper-toorak-garden-residence.json") })
        }
      }, "path---journal-wallpaper-toorak-garden-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-wallpaper-toorak-garden-residence!./.cache/json/journal-wallpaper-toorak-garden-residence.json
// module id = 557
// module chunks = 231608221292675